// extracted by css-extract-rspack-plugin
export default {"a0":"ReferenceEvaluationPage-cls1_dBP","cls1":"ReferenceEvaluationPage-cls1_NV8","cls2":"ReferenceEvaluationPage-cls2_7Ye ReferenceEvaluationPage-cls1_NV8"};